import { useMutation } from '@tanstack/react-query';

import type { ApiError } from '@/_shared';
import { apiClient } from '@/_shared';

import type {
  SubsidyItemsCreateSchema,
  SubsidyItemsFormSchema,
  SubsidyItemsMutationSchema,
} from './schemas/subsidy-items-schemas';

// commission plans APIs
export const useSubsidyItemsBulkCreateMutation = () =>
  useMutation<SubsidyItemsFormSchema[], ApiError, { items: SubsidyItemsCreateSchema[] }>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/subsidy-deliverables/bulk-store',
        payload,
      }),
  });

export const useSubsidyItemsBulkUpdateMutation = () =>
  useMutation<{ data: { id: number } }, ApiError, { items: SubsidyItemsMutationSchema[] }>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/subsidy-deliverables/bulk-update',
        payload,
      }),
  });

export const useSubsidyItemsBulkDeleteMutation = () =>
  useMutation<
    { data: { id: number } },
    ApiError,
    {
      items: number[];
    }
  >({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/subsidy-deliverables/bulk-delete',
        payload,
      }),
  });
